import { Link } from 'react-router-dom'

export default function NotFoundPage() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50">
      <div className="text-center">
        <h1 className="text-6xl font-bold text-primary-600">404</h1>
        <p className="mt-4 text-xl text-gray-600">Pagina non trovata</p>
        <Link to="/" className="mt-6 btn-primary inline-block">
          Torna alla home
        </Link>
      </div>
    </div>
  )
}
